// import React, { useEffect, useRef, useState } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import {
//   SQUARE_PLUS_ICON,
//   DELETE_ICON,
//   RIGHTARROW_IMG,
//   PROFILE_IMG,
// } from "../../utils/aap-image-constant";
// import BreadCrum from "../../components/common/BreadCrum";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ROUTES } from "../../hooks/routes/routes-constant";
// import Button from "../../components/common/button";
// import { TimePicker } from "antd";
// import dayjs from "dayjs";
// import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
// import { addDoctorAvailability, getExpertiesById } from "../../hooks/services/api-services";
// import { API_RESPONSE } from "../../utils/app-constants";
// import { handleDateFormate, handleFormInput } from "../../utils/form-utils";
// import { useSelector } from "react-redux";
// import Input from "../../components/common/input";
// import Modal from "../../components/common/Model";
// import { useTranslation } from "react-i18next";
// import { API_URL } from "../../utils/url-constants";

// const AddAvailabilty = () => {
//   const [globalTimeSlot, setGlobalTimeSlot] = useState(15);
//   const location = useLocation();
//   const { i18n, t } = useTranslation();
//   const [commonError, setCommonError] = useState({ index: null, err: "" });
//   const [weekDays, setWeekDays] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const addbuttonClick = useRef();
//   const [repeatForDay, setRepeatForDay] = useState(0);
//   const today = new Date();
//   const { value } = useSelector((state) => state?.loggedUser);
//   const userData = decryptAEStoJSON(value);
//   const formateDate = location?.state?.selectedDataAvlbty;
//   const [lumpsumpTime, setLumpSumpTime] = useState(false);
//   const [availabilityPayload, setAvailabilityPayload] = useState({
//     clinicId: location?.state?.clinicId || 0,
//     doctorId: location?.state?.doctorId || 0,
//     repeatForWeek: 0,
//     expertiseName: [],
//     // color: [],
//     dateTimeSlotsRequest: {
//       date: [formateDate],
//       timeSlots: [
//         {
//           fromTime: "",
//           toTime: "",
//           type: "online",
//           location: "",
//           locationId: 0,
//           bookingLimit: 1
//         },
//       ],
//     },
//     createdByClinic: 1,
//     languageType: i18n.language,
//   });
//   console.log("availabilityPayload", availabilityPayload);
//   const navigate = useNavigate();
//   const handleDataBack = () => {
//     navigate(ROUTES.AVAILABILITY);
//     setExpertiesData([]);
//   };
//   const handleModalClose = () => {
//     navigate(ROUTES.AVAILABILITY);
//     setExpertiesData([]);

//   };

//   const handleAddTimeSlot = () => {
//     if (availabilityPayload?.dateTimeSlotsRequest?.date?.length === 0)
//       return toastEmitter("error", "Please Select date first.");

//     if (!availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.at(-1).fromTime)
//       return;

//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev?.dateTimeSlotsRequest,
//         timeSlots: [
//           ...prev?.dateTimeSlotsRequest?.timeSlots,
//           {
//             fromTime: "",
//             toTime: "",
//             type: "online",
//             location: "",
//             locationId: 0,
//             bookingLimit: 0
//           },
//         ],
//       },
//     }));
//   };

//   const handleDeleteTimeSlot = (idx) => {
//     if (availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.length > 1) {
//       setAvailabilityPayload((prev) => ({
//         ...prev,
//         dateTimeSlotsRequest: {
//           ...prev.dateTimeSlotsRequest,
//           timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.filter(
//             (slot, index) => index !== idx
//           ),
//         },
//       }));
//     }
//   };

//   const addLumpSumpFrom = (time) => {
//     if (!time) {
//       setAvailabilityPayload((prev) => ({
//         ...prev,
//         dateTimeSlotsRequest: {
//           ...prev?.dateTimeSlotsRequest,
//           timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
//             index === 0 ? { ...slot, fromTime: "", toTime: "" } : slot
//           ),
//         },
//       }));
//       return;
//     }

//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev?.dateTimeSlotsRequest,
//         timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
//           index === 0
//             ? { ...slot, fromTime: time.format("HH:mm"), toTime: "" }
//             : slot
//         ),
//       },
//     }));
//   };
//   const addLumpSumpTo = (lastTime) => {
//     if (!lastTime) return;

//     let fromTime = dayjs(
//       availabilityPayload?.dateTimeSlotsRequest?.timeSlots[0].fromTime,
//       "HH:mm"
//     );
//     const firstToTime = fromTime.add(globalTimeSlot, "minute");

//     if (lastTime.isBefore(firstToTime)) {
//       setCommonError({
//         index: 0,
//         err: "lump sump too time should be greater than 15 minutes",
//       });
//       return;
//     }

//     const newTimeSlot = {
//       ...availabilityPayload.dateTimeSlotsRequest.timeSlots[0],
//       toTime: firstToTime.format("HH:mm"),
//     };

//     let newTimeSlotArr = [newTimeSlot];

//     fromTime = firstToTime;

//     let tempToTime = fromTime.add(globalTimeSlot, "minute");

//     while (tempToTime.isBefore(lastTime)) {
//       tempToTime = fromTime.add(globalTimeSlot, "minute");
//       newTimeSlotArr?.push({
//         ...newTimeSlot,
//         fromTime: fromTime?.format("HH:mm"),
//         toTime: tempToTime.format("HH:mm"),
//       });

//       fromTime = tempToTime;
//     }
//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev?.dateTimeSlotsRequest,
//         timeSlots: newTimeSlotArr,
//       },
//     }));
//     setLumpSumpTime(!lumpsumpTime);
//   };

//   const handleFrom = (time, slotIndex) => {
//     if (!time) {
//       setAvailabilityPayload((prev) => ({
//         ...prev,
//         dateTimeSlotsRequest: {
//           ...prev?.dateTimeSlotsRequest,
//           timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
//             index === slotIndex ? { ...slot, fromTime: "", toTime: "" } : slot
//           ),
//         },
//       }));
//       return;
//     }

//     const formattedFormTime = time.format("HH:mm");
//     const formattedToTime = time.add(globalTimeSlot, "minute").format("HH:mm");

//     const currFromTime = dayjs(time, "HH:mm");
//     const currToTime = dayjs(formattedToTime, "HH:mm");
//     for (let [
//       indx,
//       slot,
//     ] of availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.entries()) {
//       if (slotIndex === indx) continue;
//       let prevFrom = dayjs(slot?.fromTime, "HH:mm");
//       let prevTo = dayjs(slot?.toTime, "HH:mm");
//       if (currFromTime.isSame(prevFrom)) {
//         setCommonError({
//           index: slotIndex,
//           err: "From time already present in a time slot...",
//         });
//         return;
//       }
//       // checking for between from time to time
//       if (currFromTime.isAfter(prevFrom) && currFromTime.isBefore(prevTo)) {
//         setCommonError({
//           index: slotIndex,
//           err: "From time is colling with other time slot...",
//         });
//         return;
//       }

//       // checking to time for same
//       if (currToTime.isSame(prevTo)) {
//         setCommonError({ index: slotIndex, err: "To time can't be same..." });
//         return;
//       }

//       // checking to time for  between other slot
//       if (currToTime.isAfter(prevFrom) && currToTime.isBefore(prevTo)) {
//         setCommonError({
//           index: slotIndex,
//           err: "To time can't is colling with other time slot...",
//         });
//         return;
//       }
//     }

//     setCommonError({ index: null, err: "" });
//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev?.dateTimeSlotsRequest,
//         timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((s, index) =>
//           index === slotIndex
//             ? { ...s, fromTime: formattedFormTime, toTime: formattedToTime }
//             : s
//         ),
//       },
//     }));
//   };

//   const handleTo = (time, slotIndex) => {
//     if (!time) {
//       setAvailabilityPayload((prev) => ({
//         ...prev,
//         dateTimeSlotsRequest: {
//           ...prev?.dateTimeSlotsRequest,
//           timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
//             index === slotIndex ? { ...slot, fromTime: "", toTime: "" } : slot
//           ),
//         },
//       }));
//       return;
//     }

//     const formattedTime = time ? time.format("HH:mm") : "";
//     const currToTime = dayjs(formattedTime, "HH:mm");

//     const currFromTime = dayjs(
//       availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex].fromTime,
//       "HH:mm"
//     );
//     for (let [
//       indx,
//       slot,
//     ] of availabilityPayload?.dateTimeSlotsRequest?.timeSlots.entries()) {
//       if (indx === slotIndex) continue;
//       let prevFrom = dayjs(slot?.fromTime, "HH:mm");
//       if (prevFrom.isAfter(currFromTime) && currToTime.isAfter(prevFrom)) {
//         setCommonError({
//           index: slotIndex,
//           err: "To time exceeding other time slot From time...",
//         });
//         return;
//       }
//     }

//     setCommonError({ index: null, err: "" });
//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev?.dateTimeSlotsRequest,
//         timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((s, index) =>
//           index === slotIndex ? { ...s, toTime: formattedTime } : s
//         ),
//       },
//     }));
//   };

//   const handleModeChange = (slotIndex, modeValue) => {
//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev?.dateTimeSlotsRequest,
//         timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((t, ind) =>
//           ind === slotIndex
//             ? {
//               ...t,
//               type: modeValue,
//               location: modeValue === "online" ? "" : userData?.address,
//               bookingLimit: t.bookingLimit || 1
//             }
//             : t
//         ),
//       },
//     }));
//   };

//   const handleDateRepeatForWeek = (e) => {
//     setRepeatForDay(2);
//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       repeatForWeek: e.target.checked ? 1 : 0,
//     }));

//     let weekDatesArr = [];
//     const rawDate = availabilityPayload?.dateTimeSlotsRequest?.date?.[0];
//     const startDate = rawDate ? dayjs(rawDate, "DD-MM-YYYY") : dayjs();

//     weekDatesArr.push(handleDateFormate(startDate));
//     let nextDay = startDate;
//     for (let i = 0; i < 6; i++) {
//       nextDay = nextDay.add(1, "day");
//       weekDatesArr.push(handleDateFormate(nextDay));
//     }
//     setWeekDays(weekDatesArr);
//     setAvailabilityPayload((prev) => ({
//       ...prev,
//       dateTimeSlotsRequest: {
//         ...prev.dateTimeSlotsRequest,
//         date: [handleDateFormate(startDate)],
//       },
//     }));
//   };

//   const handleDateAdd = (newDate) => {
//     if (repeatForDay === 0) {
//       const formatedDate = handleDateFormate(newDate);
//       setAvailabilityPayload((prev) => ({
//         ...prev,
//         dateTimeSlotsRequest: {
//           ...prev?.dateTimeSlotsRequest,
//           date: [formatedDate],
//         },
//       }));
//     } else if (repeatForDay === 2) {
//       const formatedDate = handleDateFormate(newDate);
//       let weekDatesArr = [];
//       const startDate = dayjs(newDate);
//       weekDatesArr.push(handleDateFormate(startDate));
//       let nextDay = startDate;
//       for (let i = 0; i < 6; i++) {
//         nextDay = nextDay.add(1, "day");
//         weekDatesArr.push(handleDateFormate(nextDay));
//       }
//       setWeekDays(weekDatesArr);
//       setAvailabilityPayload((prev) => ({
//         ...prev,
//         dateTimeSlotsRequest: {
//           ...prev?.dateTimeSlotsRequest,
//           date: [formatedDate],
//         },
//       }));
//     } else {
//       const dateStr = handleDateFormate(newDate);
//       const formatedDate = handleDateFormate(newDate);
//       setAvailabilityPayload((prev) => {
//         const dates = prev?.dateTimeSlotsRequest?.date;
//         const exists = dates?.includes(dateStr); // change if using dayjs objects
//         const updatedDates = exists
//           ? dates.length === 1
//             ? dates
//             : dates.filter((d) => d !== dateStr)
//           : [...dates, formatedDate];
//         return {
//           ...prev,
//           dateTimeSlotsRequest: {
//             ...prev?.dateTimeSlotsRequest,
//             date: updatedDates,
//           },
//         };
//       });
//     }
//     return;
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (availabilityPayload?.clinicId === 0) {
//       return toastEmitter("error", "CLinic id is mandatory");
//     }
//     if (availabilityPayload?.doctorId === 0) {
//       return toastEmitter("error", "Doctor id is mandatory");
//     }
//     if (availabilityPayload?.dateTimeSlotsRequest?.date?.length === 0) {
//       return toastEmitter("error", "please select a date");
//     }
//     for (let slot of availabilityPayload?.dateTimeSlotsRequest?.timeSlots) {
//       if (!slot?.fromTime || !slot?.toTime)
//         return toastEmitter("error", "Please fill the empty time slot");
//     }

//     // const payload = {
//     //   ...availabilityPayload,
//     //   expertise: Array.isArray(availabilityPayload.expertise)
//     //     ? availabilityPayload.expertise
//     //     : availabilityPayload.expertise
//     //       ? [availabilityPayload.expertise]
//     //       : [],
//     // };

//     const payload = {
//     clinicId: availabilityPayload.clinicId,
//     doctorId: availabilityPayload.doctorId,
//     repeatForWeek: availabilityPayload.repeatForWeek,
//     expertiseName: availabilityPayload.expertiseName, //  correct field
//     dateTimeSlotsRequest: availabilityPayload.dateTimeSlotsRequest,
//     createdByClinic: availabilityPayload.createdByClinic,
//     languageType: availabilityPayload.languageType,
//   };


//     setIsLoading(true);
//     try {
//       const response = await addDoctorAvailability(payload);
//       if (response?.data?.status !== 200) {
//         toastEmitter("error", response?.data?.message);
//       } else {
//         toastEmitter("success", response?.data?.message);
//         setAvailabilityPayload({
//           clinicId: location?.state?.clinicId || 0,
//           doctorId: location?.state?.doctorId || 0,
//           repeatForWeek: 0,
//           expertiseName: [],
//           // color: [],
//           dateTimeSlotsRequest: {
//             date: [],
//             timeSlots: [
//               {
//                 fromTime: "",
//                 toTime: "",
//                 type: "online",
//                 location: "",
//                 locationId: 0,
//                 bookingLimit: 1

//               },
//             ],
//           },
//           createdByClinic: 1,
//           languageType: i18n.language,
//         });
//         navigate("/availability", {
//           state: {
//             reopenAvailabilityModal: true,
//             doctorId: location?.state?.doctorId,
//             clinicId: location?.state?.clinicId,
//             selectedDate: new Date(),
//             doctorDetails: location?.state?.doctorDetails,
//           },
//         });

//         setExpertiesData([]);
//       }
//     } catch (err) {
//       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // get all experties in doctor
//   const [expertiesData, setExpertiesData] = useState([])
//   const fetchAllExpertiesList = async () => {
//     try {
//       const response = await getExpertiesById(location?.state?.doctorId, i18n.language);
//       if (response?.data?.status !== 200) {
//         // toastEmitter("error", response?.data?.message);
//         setExpertiesData([]);
//       } else {
//         setExpertiesData(response?.data?.data?.expertiseName);
//       }
//     } catch (err) {
//       // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     }
//   };

//   useEffect(() => {
//     if (location?.state?.doctorId) {
//       fetchAllExpertiesList();
//     }
//   }, [i18n.language, location?.state?.doctorId]);
//   console.log("availability payload", availabilityPayload)
//   return (
//     <>
//       <div className="main_datatable my-lg-3 my-2">
//         <div className="">
//           <BreadCrum
//             firstData={t("Availability Management")}
//             iconshow1={true}
//             secondData={t("Add Availability")}
//             onFirstDataClick={handleDataBack}
//           />

//           <form>
//             <div className="card p-1 border p-md-3">
//               <div className="d-flex flex-wrap align-items-center mb-3">
//                 <img
//                   src={
//                     location?.state?.doctorDetails?.image
//                       ? `${API_URL?.ServerURL}${location?.state?.doctorDetails?.image}`
//                       : PROFILE_IMG
//                   }
//                   alt="Profile"
//                   className="rounded-3"
//                   style={{
//                     width: "100px",
//                     height: "100px",
//                     objectFit: "cover",
//                   }}
//                 />
//                 <div
//                   className={` ms-3 ${i18n.language === "ar" ? "me-3" : ""} `}
//                 >
//                   <h5 className="mb-0 fs-6 fw-bolder">
//                     {" "}
//                     Dr.{" "}
//                     {location?.state?.doctorDetails &&
//                       location?.state?.doctorDetails?.firstName}{" "}
//                     {location?.state?.doctorDetails &&
//                       location?.state?.doctorDetails?.lastName}
//                   </h5>
//                   <p className="text-muted mb-0">
//                     {location?.state?.doctorDetails &&
//                       location?.state?.doctorDetails?.email}
//                   </p>
//                 </div>
//               </div>

//               <div className="row">
//                 <div className="col-12 col-lg-5 mb-2">
//                   <h5 className="mb-3 fw-bold">{t("Add Availability")}</h5>
//                   <div className="card mb-2">
//                     <div className="card-body">
//                       <Calendar
//                         minDate={today}
//                         onClickDay={handleDateAdd}
//                         locale={i18n.language}
//                         value={null}
//                         tileClassName={({ date, view }) => {
//                           if (view === "month") {
//                             const isSelected =
//                               availabilityPayload?.repeatForWeek === 1
//                                 ? weekDays?.some((d) => {
//                                   const [day, month, year] = d.split("-");
//                                   const formattedD = `${year}-${month}-${day}`;
//                                   return dayjs(formattedD).isSame(
//                                     dayjs(date),
//                                     "day"
//                                   );
//                                   // return new date(d).toDateString() === date.toDateString() ;
//                                 })
//                                 : availabilityPayload?.dateTimeSlotsRequest?.date?.some(
//                                   (d) => {
//                                     const [day, month, year] = d.split("-");
//                                     const formattedD = `${year}-${month}-${day}`;
//                                     return dayjs(formattedD).isSame(
//                                       dayjs(date),
//                                       "day"
//                                     );
//                                   }
//                                 );

//                             return isSelected
//                               ? "rounded10 bg-blue text-white"
//                               : null;
//                           }
//                         }}
//                         className="w-100 border-0"
//                       />
//                     </div>
//                   </div>

//                   <div className="row ms-1">
//                     <div className="form-check col-sm-6">
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         id="exampleCheck1"
//                         onChange={(e) => {
//                           if (e.target.checked) {
//                             setRepeatForDay(0);
//                             setAvailabilityPayload((prev) => ({
//                               ...prev,
//                               repeatForWeek: 0,
//                               dateTimeSlotsRequest: {
//                                 ...prev?.dateTimeSlotsRequest,
//                                 date: [prev?.dateTimeSlotsRequest?.date[0]],
//                               },
//                             }));
//                             setWeekDays([]);
//                           }
//                         }}
//                         checked={repeatForDay === 0}
//                       />
//                       <label
//                         className="form-check-label m-0"
//                         htmlFor="exampleCheck1"
//                       >
//                         {t("noRepeat")}
//                       </label>
//                     </div>

//                     <div className="form-check col-sm-6">
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         id="exampleCheck2"
//                         onChange={(e) => {
//                           setRepeatForDay(1);
//                           setAvailabilityPayload((prev) => ({
//                             ...prev,
//                             repeatForWeek: 0,
//                           }));
//                           setWeekDays([]);
//                         }}
//                         checked={repeatForDay === 1}
//                       />
//                       <label
//                         className="form-check-label m-0"
//                         htmlFor="exampleCheck2"
//                       >
//                         {t("repeatByDate")}
//                       </label>
//                     </div>

//                     <div className=" form-check col-sm-6">
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         id="exampleCheck3"
//                         onChange={handleDateRepeatForWeek}
//                         checked={repeatForDay === 2}
//                       />
//                       <label
//                         className="form-check-label m-0"
//                         for="exampleCheck1"
//                       >
//                         {t("repeatForWeek")}
//                       </label>
//                     </div>

//                     {availabilityPayload?.dateTimeSlotsRequest?.timeSlots
//                       ?.length <= 1 && (
//                         <div className=" form-check col-sm-6">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="exampleCheck1"
//                             checked={lumpsumpTime}
//                             onChange={() => setLumpSumpTime(!lumpsumpTime)}
//                           />
//                           <label
//                             className="form-check-label m-0"
//                             for="exampleCheck1"
//                           >
//                             {t("Create")} full day slot
//                           </label>
//                         </div>
//                       )}
//                   </div>
//                 </div>
//                 {/* **********************************************
//                  ********************************************** */}
//                 <div className="col-12 col-lg-7 ">
//                   <div className="d-flex justify-content-between ">
//                     <h5 className="sec-heading my-0 ">{t("Add Time Slot")}</h5>
//                     <div className="d-flex gap-2 justify-content-end">
//                       <label className="my-0">Appointment duration</label>
//                       <input
//                         type="number"
//                         className="form-control w-25 mb-3 py-0"
//                         value={globalTimeSlot}
//                         onChange={(e) => setGlobalTimeSlot(e.target.value)}
//                         onKeyDown={(e) => {
//                           if (
//                             [
//                               "e",
//                               "E",
//                               "+",
//                               "-",
//                               ".",
//                               "ArrowUp",
//                               "ArrowDown",
//                             ].includes(e.key)
//                           ) {
//                             e.preventDefault();
//                           }
//                         }}
//                         onWheel={(e) => e.target.blur()}
//                       />

//                       {!lumpsumpTime && (
//                         <span
//                           onClick={handleAddTimeSlot}
//                           className="cursor-pointer"
//                         >
//                           <img src={SQUARE_PLUS_ICON} alt="square_plus_icon " />
//                         </span>
//                       )}
//                     </div>
//                   </div>

//                   <div className="dropdown-container mb-2">
//                     {/* <select
//                       className="form-select"
//                       name="expertise"
//                       value={availabilityPayload?.expertise}
//                       onChange={(e) => setAvailabilityPayload(handleFormInput(e, availabilityPayload))}
//                     >
//                       <option value="" className="font-primary">
//                         Select Expertise
//                       </option>
//                       {expertiesData &&
//                         [...expertiesData]
//                           .sort((a, b) => a?.expertiseName?.localeCompare(b?.expertiseName))
//                           .map((item, index) => (
//                             <option key={index} value={item?.expertiseName}>
//                               {item?.expertiseName}
//                             </option>
//                           ))}
//                     </select> */}

//                     <div className="dropdown w-100 position-relative">
//                       <button
//                         type="button"
//                         className="btn btn-outline-primary dropdown-toggle w-100 text-start"
//                         onClick={() =>
//                           setAvailabilityPayload((prev) => ({
//                             ...prev,
//                             isExpertiseOpen: !prev.isExpertiseOpen,
//                           }))
//                         }
//                       >
//                         {availabilityPayload.expertiseName?.length > 0 ? (
//                           availabilityPayload.expertiseName.map((e, i) => (
//                             <span
//                               key={i}
//                               style={{ color: e.color, fontWeight: "600", marginRight: "6px" }}
//                             >
//                               {e.expertiseName}
//                               {i < availabilityPayload.expertiseName.length - 1 ? "," : ""}
//                             </span>
//                           ))
//                         ) : (
//                           t("Select Expertise")
//                         )}
//                       </button>

//                       <ul
//                         className={`dropdown-menu w-100 p-2 ${availabilityPayload.isExpertiseOpen ? "show" : ""
//                           }`}
//                         style={{ maxHeight: "200px", overflowY: "auto" }}
//                       >
//                         {expertiesData &&
//                           [...expertiesData]
//                             .sort((a, b) => a.expertiseName.localeCompare(b.expertiseName))
//                             .map((item, index) => {
//                               const selected = availabilityPayload.expertiseName?.some(
//                                 (e) => e.expertiseName === item.expertiseName
//                               );

//                               const existing = availabilityPayload.expertiseName?.find(
//                                 (e) => e.expertiseName === item.expertiseName
//                               );

//                               const color =
//                                 existing?.color ||
//                                 `#${Math.floor(Math.random() * 16777215).toString(16)}`;

//                               return (
//                                 <li key={index} className="px-1 py-1">
//                                   <div className="form-check d-flex align-items-center">
//                                     <input
//                                       className="form-check-input me-2"
//                                       type="checkbox"
//                                       id={`expertise-${index}`}
//                                       checked={selected}
//                                       onChange={() => {
//                                         let newExpertise = [...availabilityPayload.expertiseName];

//                                         if (selected) {
//                                           newExpertise = newExpertise.filter(
//                                             (e) => e.expertiseName !== item.expertiseName
//                                           );
//                                         } else {
//                                           newExpertise.push({
//                                             expertiseName: item.expertiseName,
//                                             color,
//                                           });
//                                         }

//                                         setAvailabilityPayload((prev) => ({
//                                           ...prev,
//                                           expertiseName: newExpertise,
//                                         }));
//                                       }}
//                                       style={{ accentColor: color }}
//                                     />
//                                     <p
//                                       className="form-check-label mb-0"
//                                       htmlFor={`expertise-${index}`}
//                                       style={{
//                                         cursor: "pointer",
//                                         color: color,
//                                         fontWeight: selected ? "600" : "400",
//                                       }}
//                                     >
//                                       {item.expertiseName}
//                                     </p>
//                                   </div>
//                                 </li>
//                               );
//                             })}
//                       </ul>
//                     </div>



//                   </div>





//                   <div
//                     className="overflow-y-auto "
//                     style={{ maxHeight: "330px" }}
//                   >
//                     {availabilityPayload?.dateTimeSlotsRequest?.timeSlots &&
//                       availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.map(
//                         (slot, slotIndex) => (
//                           <div className="card mb-2">
//                             <div className="card-body">
//                               <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
//                                 <h6 className="card-title fw-normal m-0">
//                                   {t("Time Slots")} {slotIndex + 1}
//                                 </h6>

//                                 {availabilityPayload?.dateTimeSlotsRequest
//                                   ?.timeSlots?.length > 1 && (
//                                     <span
//                                       className="col text-end"
//                                       onClick={() =>
//                                         handleDeleteTimeSlot(slotIndex)
//                                       }
//                                     >
//                                       <img
//                                         src={DELETE_ICON}
//                                         alt="delete_icon"
//                                         className="cursor-pointer"
//                                       />
//                                     </span>
//                                   )}
//                               </div>
//                               <hr className="mt-0" />
//                               <div className="d-flex justify-content-between">
//                                 <div></div>
//                               </div>

//                               {/* Add slot code  */}
//                               <div className="row g-3 ">
//                                 <div className="">
//                                   <div className="d-flex flex-wrap gap-2">
//                                     <button
//                                       type="button"
//                                       className={`btn  ${availabilityPayload
//                                         ?.dateTimeSlotsRequest?.timeSlots[
//                                         slotIndex
//                                       ].type === "online"
//                                         ? "btn-primary"
//                                         : " btn-outline-info"
//                                         } btn-sm  px-4  mb-2 rounded-3`}
//                                       onClick={() =>
//                                         handleModeChange(slotIndex, "online")
//                                       }
//                                     >
//                                       {t("Online")}
//                                     </button>
//                                     <button
//                                       type="button"
//                                       className={`btn ${availabilityPayload
//                                         ?.dateTimeSlotsRequest?.timeSlots[
//                                         slotIndex
//                                       ].type === "offline"
//                                         ? "btn-primary"
//                                         : "btn-outline-info"
//                                         }  btn-sm  px-4 me-2 mb-2 rounded-3`}
//                                       onClick={() =>
//                                         handleModeChange(slotIndex, "offline")
//                                       }
//                                     >
//                                       {t("Offline")}
//                                     </button>
//                                   </div>

//                                   <div className="row g-2">
//                                     <div className="col-6 ">
//                                       {/* <TimePicker
//                                         value={
//                                           slot?.fromTime
//                                             ? dayjs(slot?.fromTime, "HH:mm")
//                                             : null
//                                         }
//                                         className={"form-control"}
//                                         format="HH:mm"
//                                         placeholder="From"
//                                         onChange={(time) =>
//                                           lumpsumpTime
//                                             ? addLumpSumpFrom(time || "")
//                                             : handleFrom(time || "", slotIndex)
//                                         }
//                                       /> */}
//                                       <TimePicker
//                                         value={
//                                           slot?.fromTime
//                                             ? dayjs(slot?.fromTime, "HH:mm")
//                                             : null
//                                         }
//                                         className={"form-control"}
//                                         format="HH:mm"
//                                         placeholder="From"
//                                         onChange={(time) =>
//                                           lumpsumpTime
//                                             ? addLumpSumpFrom(time || "")
//                                             : handleFrom(time || "", slotIndex)
//                                         }
//                                         disabledTime={() => {
//                                           const selectedDateStr = availabilityPayload?.dateTimeSlotsRequest?.date?.[0]; // e.g., "05-08-2025"
//                                           if (!selectedDateStr) return {};

//                                           const [day, month, year] = selectedDateStr.split("-");
//                                           const selectedDate = dayjs(`${year}-${month}-${day}`, "YYYY-MM-DD");
//                                           const now = dayjs();

//                                           if (repeatForDay === 0 && selectedDate.isSame(dayjs(), "day")) {
//                                             const currentHour = now.hour();
//                                             const currentMinute = now.minute();

//                                             return {
//                                               disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
//                                               disabledMinutes: (hour) =>
//                                                 hour === currentHour
//                                                   ? Array.from({ length: currentMinute }, (_, i) => i)
//                                                   : [],
//                                             };
//                                           }

//                                           return {};
//                                         }}
//                                       />

//                                     </div>
//                                     <div className="col-6">
//                                       <TimePicker
//                                         value={
//                                           slot?.toTime
//                                             ? dayjs(slot?.toTime, "HH:mm")
//                                             : null
//                                         }
//                                         className={"form-control"}
//                                         format="HH:mm"
//                                         placeholder="To"
//                                         onChange={(time) =>
//                                           lumpsumpTime
//                                             ? addLumpSumpTo(time || "")
//                                             : handleTo(time || "", slotIndex)
//                                         }
//                                         disabled={!slot?.fromTime}
//                                         disabledTime={() => {
//                                           if (!slot.fromTime) return {};
//                                           const fromTime = dayjs(
//                                             slot?.fromTime,
//                                             "HH:mm"
//                                           );
//                                           return {
//                                             disabledHours: () => [
//                                               ...Array(fromTime.hour()).keys(),
//                                             ],
//                                             disabledMinutes: (h) =>
//                                               h === fromTime.hour()
//                                                 ? [
//                                                   ...Array(
//                                                     fromTime.minute() +
//                                                     globalTimeSlot
//                                                   ).keys(),
//                                                 ]
//                                                 : [],
//                                           };
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                   {slot?.type === "offline" && (
//                                     <div className="row g-2">
//                                       <div className=" col-sm-6">
//                                         <Input
//                                           className="border-radius_input py-2"
//                                           type="text"
//                                           value={
//                                             availabilityPayload
//                                               ?.dateTimeSlotsRequest?.timeSlots[
//                                               slotIndex
//                                             ].location
//                                           }
//                                           name="location"
//                                           disabled
//                                           labelName={t("Location")}
//                                         />
//                                       </div>

//                                       {/* <div className="col-sm-6">
//                                         <Input
//                                           className="border-radius_input py-2"
//                                           type="number"
//                                           value={
//                                             availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex]
//                                               .bookingLimit === 0
//                                               ? ""
//                                               : availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex]
//                                                 .bookingLimit
//                                           }
//                                           name="bookingLimit"
//                                           labelName={t("Slot Booking Limit")}
//                                           onChange={(e) => {
//                                             const value = e.target.value === "" ? 0 : parseInt(e.target.value, 10);
//                                             setAvailabilityPayload((prev) => {
//                                               const updatedSlots = [...prev.dateTimeSlotsRequest.timeSlots];
//                                               updatedSlots[slotIndex] = {
//                                                 ...updatedSlots[slotIndex],
//                                                 bookingLimit: value,
//                                               };
//                                               return {
//                                                 ...prev,
//                                                 dateTimeSlotsRequest: {
//                                                   ...prev.dateTimeSlotsRequest,
//                                                   timeSlots: updatedSlots,
//                                                 },
//                                               };
//                                             });
//                                           }}
//                                           onKeyDown={(e) => {
//                                             if (
//                                               ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(e.key)
//                                             ) {
//                                               e.preventDefault();
//                                             }
//                                           }}
//                                           onWheel={(e) => e.target.blur()} // Prevent mouse scroll changing number
//                                         />
//                                       </div> */}

//                                       <div className="col-sm-6">
//                                         <Input
//                                           type="number"
//                                           min={1}
//                                           value={
//                                             availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex]
//                                               .bookingLimit
//                                           }
//                                           labelName={t("Slot Booking Limit")}
//                                           onChange={(e) => {
//                                             const value = Math.max(1, Number(e.target.value || 1));

//                                             setAvailabilityPayload((prev) => {
//                                               const updatedSlots = [...prev.dateTimeSlotsRequest.timeSlots];
//                                               updatedSlots[slotIndex] = {
//                                                 ...updatedSlots[slotIndex],
//                                                 bookingLimit: value,
//                                               };
//                                               return {
//                                                 ...prev,
//                                                 dateTimeSlotsRequest: {
//                                                   ...prev.dateTimeSlotsRequest,
//                                                   timeSlots: updatedSlots,
//                                                 },
//                                               };
//                                             });
//                                           }}
//                                           onKeyDown={(e) => {
//                                             if (["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(e.key)) {
//                                               e.preventDefault();
//                                             }
//                                           }}
//                                           onWheel={(e) => e.target.blur()}
//                                         />

//                                       </div>

//                                     </div>
//                                   )}


//                                 </div>
//                                 {/* ))} */}
//                                 {commonError.index === slotIndex && (
//                                   <span className="fs-6 text-danger">
//                                     {" "}
//                                     {commonError.err}
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                         )
//                       )}
//                   </div>
//                 </div>
//               </div>
//               <div className="d-flex flex-wrap  justify-content-center ">
//                 <Button
//                   type="button"
//                   className={`px-5 py-2 rounded border-0  cancelbtn  mb-md-0 mb-2 ${i18n.language === "ar" ? "ms-2" : "me-2"
//                     }`}
//                   label="Cancel"
//                   onClick={handleDataBack}
//                 />
//                 <Button
//                   type="button"
//                   className="px-5 py-2 rounded border-0 text-white submitbtn mb-2 mb-md-0"
//                   label={t("Add Availability")}
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                 />
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//       <Modal
//         modalId="availabilityadd"
//         heading="Availability Added Successfully"
//         modalClick={addbuttonClick}
//         iconsrc={RIGHTARROW_IMG}
//         paragraph="Doctor Availability Added Successfully. You can manage it from availability management section."
//         handleModalClose={handleModalClose}
//       />
//     </>
//   );
// };

// export default AddAvailabilty;


import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  SQUARE_PLUS_ICON,
  DELETE_ICON,
  RIGHTARROW_IMG,
  PROFILE_IMG,
} from "../../utils/aap-image-constant";
import BreadCrum from "../../components/common/BreadCrum";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import Button from "../../components/common/button";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
import { addDoctorAvailability, getExpertiesById } from "../../hooks/services/api-services";
import { API_RESPONSE } from "../../utils/app-constants";
import { handleDateFormate, handleFormInput, localToUtcTime, utcToLocalDayjs } from "../../utils/form-utils";
import { useSelector } from "react-redux";
import Input from "../../components/common/input";
import Modal from "../../components/common/Model";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../utils/url-constants";

const AddAvailabilty = () => {
  const [globalTimeSlot, setGlobalTimeSlot] = useState(15);
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const [commonError, setCommonError] = useState({ index: null, err: "" });
  const [weekDays, setWeekDays] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const addbuttonClick = useRef();
  const [repeatForDay, setRepeatForDay] = useState(0);
  const today = new Date();
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const formateDate = location?.state?.selectedDataAvlbty;
  const [lumpsumpTime, setLumpSumpTime] = useState(false);
  const [availabilityPayload, setAvailabilityPayload] = useState({
    clinicId: location?.state?.clinicId || 0,
    doctorId: location?.state?.doctorId || 0,
    repeatForWeek: 0,
    expertiseName: [],
    // color: [],
    dateTimeSlotsRequest: {
      date: [formateDate],
      timeSlots: [
        {
          fromTime: "",
          toTime: "",
          type: "online",
          location: "",
          locationId: 0,
          bookingLimit: 1
        },
      ],
    },
    createdByClinic: 1,
    languageType: i18n.language,
  });
  console.log("availabilityPayload", availabilityPayload);
  const navigate = useNavigate();

  const handleDataBack = () => {
    navigate(ROUTES.AVAILABILITY);
    setExpertiesData([]);
  };
  const handleModalClose = () => {
    navigate(ROUTES.AVAILABILITY);
    setExpertiesData([]);

  };

  const handleAddTimeSlot = () => {
    if (availabilityPayload?.dateTimeSlotsRequest?.date?.length === 0)
      return toastEmitter("error", "Please Select date first.");

    if (!availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.at(-1).fromTime)
      return;

    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev?.dateTimeSlotsRequest,
        timeSlots: [
          ...prev?.dateTimeSlotsRequest?.timeSlots,
          {
            fromTime: "",
            toTime: "",
            type: "online",
            location: "",
            locationId: 0,
            bookingLimit: 0
          },
        ],
      },
    }));
  };

  const handleDeleteTimeSlot = (idx) => {
    if (availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.length > 1) {
      setAvailabilityPayload((prev) => ({
        ...prev,
        dateTimeSlotsRequest: {
          ...prev.dateTimeSlotsRequest,
          timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.filter(
            (slot, index) => index !== idx
          ),
        },
      }));
    }
  };

  const addLumpSumpFrom = (time) => {
    if (!time) {
      setAvailabilityPayload((prev) => ({
        ...prev,
        dateTimeSlotsRequest: {
          ...prev?.dateTimeSlotsRequest,
          timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
            index === 0 ? { ...slot, fromTime: "", toTime: "" } : slot
          ),
        },
      }));
      return;
    }

    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev?.dateTimeSlotsRequest,
        timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
          index === 0
            ? {
              ...slot, fromTime:
                // time.format("HH:mm"),
                localToUtcTime(time),
              toTime: ""
            }
            : slot
        ),
      },
    }));
  };
  const addLumpSumpTo = (lastTime) => {
    if (!lastTime) return;

    let fromTime = dayjs(
      availabilityPayload?.dateTimeSlotsRequest?.timeSlots[0].fromTime,
      "HH:mm"
    );
    const firstToTime = fromTime.add(globalTimeSlot, "minute");

    if (lastTime.isBefore(firstToTime)) {
      setCommonError({
        index: 0,
        err: "lump sump too time should be greater than 15 minutes",
      });
      return;
    }

    const newTimeSlot = {
      ...availabilityPayload.dateTimeSlotsRequest.timeSlots[0],
      toTime: firstToTime.format("HH:mm"),
    };

    let newTimeSlotArr = [newTimeSlot];

    fromTime = firstToTime;

    let tempToTime = fromTime.add(globalTimeSlot, "minute");

    while (tempToTime.isBefore(lastTime)) {
      tempToTime = fromTime.add(globalTimeSlot, "minute");
      newTimeSlotArr?.push({
        ...newTimeSlot,
        fromTime: fromTime?.format("HH:mm"),
        toTime: tempToTime.format("HH:mm"),
      });

      fromTime = tempToTime;
    }
    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev?.dateTimeSlotsRequest,
        timeSlots: newTimeSlotArr,
      },
    }));
    setLumpSumpTime(!lumpsumpTime);
  };

  const handleFrom = (time, slotIndex) => {
    if (!time) {
      setAvailabilityPayload((prev) => ({
        ...prev,
        dateTimeSlotsRequest: {
          ...prev?.dateTimeSlotsRequest,
          timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
            index === slotIndex ? { ...slot, fromTime: "", toTime: "" } : slot
          ),
        },
      }));
      return;
    }

    // const formattedFormTime = time.format("HH:mm");
    // const formattedToTime = time.add(globalTimeSlot, "minute").format("HH:mm");
    const formattedFormTime = localToUtcTime(time);
    const formattedToTime = localToUtcTime(
      time.add(globalTimeSlot, "minute")
    );

    const currFromTime = dayjs(time, "HH:mm");
    const currToTime = dayjs(formattedToTime, "HH:mm");
    for (let [
      indx,
      slot,
    ] of availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.entries()) {
      if (slotIndex === indx) continue;
      let prevFrom =
        // dayjs(slot?.fromTime, "HH:mm");
        dayjs.utc(slot.fromTime, "HH:mm").local();
      let prevTo =
        // dayjs(slot?.toTime, "HH:mm");
        dayjs.utc(slot.toTime, "HH:mm").local();

      if (currFromTime.isSame(prevFrom)) {
        setCommonError({
          index: slotIndex,
          err: "From time already present in a time slot...",
        });
        return;
      }
      // checking for between from time to time
      if (currFromTime.isAfter(prevFrom) && currFromTime.isBefore(prevTo)) {
        setCommonError({
          index: slotIndex,
          err: "From time is colling with other time slot...",
        });
        return;
      }

      // checking to time for same
      if (currToTime.isSame(prevTo)) {
        setCommonError({ index: slotIndex, err: "To time can't be same..." });
        return;
      }

      // checking to time for  between other slot
      if (currToTime.isAfter(prevFrom) && currToTime.isBefore(prevTo)) {
        setCommonError({
          index: slotIndex,
          err: "To time can't is colling with other time slot...",
        });
        return;
      }
    }

    setCommonError({ index: null, err: "" });
    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev?.dateTimeSlotsRequest,
        timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((s, index) =>
          index === slotIndex
            ? { ...s, fromTime: formattedFormTime, toTime: formattedToTime }
            : s
        ),
      },
    }));
  };

  const handleTo = (time, slotIndex) => {
    if (!time) {
      setAvailabilityPayload((prev) => ({
        ...prev,
        dateTimeSlotsRequest: {
          ...prev?.dateTimeSlotsRequest,
          timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((slot, index) =>
            index === slotIndex ? { ...slot, fromTime: "", toTime: "" } : slot
          ),
        },
      }));
      return;
    }

    // const formattedTime = time ? time.format("HH:mm") : "";
    const formattedTime = localToUtcTime(time);

    const currToTime = dayjs(formattedTime, "HH:mm");

    const currFromTime = dayjs(
      availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex].fromTime,
      "HH:mm"
    );
    for (let [
      indx,
      slot,
    ] of availabilityPayload?.dateTimeSlotsRequest?.timeSlots.entries()) {
      if (indx === slotIndex) continue;
      let prevFrom = dayjs(slot?.fromTime, "HH:mm");
      if (prevFrom.isAfter(currFromTime) && currToTime.isAfter(prevFrom)) {
        setCommonError({
          index: slotIndex,
          err: "To time exceeding other time slot From time...",
        });
        return;
      }
    }

    setCommonError({ index: null, err: "" });
    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev?.dateTimeSlotsRequest,
        timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((s, index) =>
          index === slotIndex ? { ...s, toTime: formattedTime } : s
        ),
      },
    }));
  };

  const handleModeChange = (slotIndex, modeValue) => {
    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev?.dateTimeSlotsRequest,
        timeSlots: prev?.dateTimeSlotsRequest?.timeSlots?.map((t, ind) =>
          ind === slotIndex
            ? {
              ...t,
              type: modeValue,
              location: modeValue === "online" ? "" : userData?.address,
              bookingLimit: t.bookingLimit || 1
            }
            : t
        ),
      },
    }));
  };

  const handleDateRepeatForWeek = (e) => {
    setRepeatForDay(2);
    setAvailabilityPayload((prev) => ({
      ...prev,
      repeatForWeek: e.target.checked ? 1 : 0,
    }));

    let weekDatesArr = [];
    const rawDate = availabilityPayload?.dateTimeSlotsRequest?.date?.[0];
    const startDate = rawDate ? dayjs(rawDate, "DD-MM-YYYY") : dayjs();

    weekDatesArr.push(handleDateFormate(startDate));
    let nextDay = startDate;
    for (let i = 0; i < 6; i++) {
      nextDay = nextDay.add(1, "day");
      weekDatesArr.push(handleDateFormate(nextDay));
    }
    setWeekDays(weekDatesArr);
    setAvailabilityPayload((prev) => ({
      ...prev,
      dateTimeSlotsRequest: {
        ...prev.dateTimeSlotsRequest,
        date: [handleDateFormate(startDate)],
      },
    }));
  };

  const handleDateAdd = (newDate) => {
    if (repeatForDay === 0) {
      const formatedDate = handleDateFormate(newDate);
      setAvailabilityPayload((prev) => ({
        ...prev,
        dateTimeSlotsRequest: {
          ...prev?.dateTimeSlotsRequest,
          date: [formatedDate],
        },
      }));
    } else if (repeatForDay === 2) {
      const formatedDate = handleDateFormate(newDate);
      let weekDatesArr = [];
      const startDate = dayjs(newDate);
      weekDatesArr.push(handleDateFormate(startDate));
      let nextDay = startDate;
      for (let i = 0; i < 6; i++) {
        nextDay = nextDay.add(1, "day");
        weekDatesArr.push(handleDateFormate(nextDay));
      }
      setWeekDays(weekDatesArr);
      setAvailabilityPayload((prev) => ({
        ...prev,
        dateTimeSlotsRequest: {
          ...prev?.dateTimeSlotsRequest,
          date: [formatedDate],
        },
      }));
    } else {
      const dateStr = handleDateFormate(newDate);
      const formatedDate = handleDateFormate(newDate);
      setAvailabilityPayload((prev) => {
        const dates = prev?.dateTimeSlotsRequest?.date;
        const exists = dates?.includes(dateStr); // change if using dayjs objects
        const updatedDates = exists
          ? dates.length === 1
            ? dates
            : dates.filter((d) => d !== dateStr)
          : [...dates, formatedDate];
        return {
          ...prev,
          dateTimeSlotsRequest: {
            ...prev?.dateTimeSlotsRequest,
            date: updatedDates,
          },
        };
      });
    }
    return;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (availabilityPayload?.clinicId === 0) {
      return toastEmitter("error", "CLinic id is mandatory");
    }
    if (availabilityPayload?.doctorId === 0) {
      return toastEmitter("error", "Doctor id is mandatory");
    }
    if (!availabilityPayload?.expertiseName ||
    availabilityPayload.expertiseName.length === 0) {
  return toastEmitter("error", "Please select your expertise");
}

    if (availabilityPayload?.dateTimeSlotsRequest?.date?.length === 0) {
      return toastEmitter("error", "please select a date");
    }
    for (let slot of availabilityPayload?.dateTimeSlotsRequest?.timeSlots) {
      if (!slot?.fromTime || !slot?.toTime)
        return toastEmitter("error", "Please fill the empty time slot");
    }

    // const payload = {
    //   ...availabilityPayload,
    //   expertise: Array.isArray(availabilityPayload.expertise)
    //     ? availabilityPayload.expertise
    //     : availabilityPayload.expertise
    //       ? [availabilityPayload.expertise]
    //       : [],
    // };

    const payload = {
      clinicId: availabilityPayload.clinicId,
      doctorId: availabilityPayload.doctorId,
      repeatForWeek: availabilityPayload.repeatForWeek,
      expertiseName: availabilityPayload.expertiseName.map((e) => ({
        expertiseName: e.expertiseName,
        color: e.color || "#000000", 
      })),
      dateTimeSlotsRequest: availabilityPayload.dateTimeSlotsRequest,
      createdByClinic: availabilityPayload.createdByClinic,
      languageType: availabilityPayload.languageType,
    };


    setIsLoading(true);
    try {
      const response = await addDoctorAvailability(payload);
      if (response?.data?.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);
        setAvailabilityPayload({
          clinicId: location?.state?.clinicId || 0,
          doctorId: location?.state?.doctorId || 0,
          repeatForWeek: 0,
          expertiseName: [],
          // color: [],
          dateTimeSlotsRequest: {
            date: [],
            timeSlots: [
              {
                fromTime: "",
                toTime: "",
                type: "online",
                location: "",
                locationId: 0,
                bookingLimit: 1

              },
            ],
          },
          createdByClinic: 1,
          languageType: i18n.language,
        });
        navigate("/availability", {
          state: {
            reopenAvailabilityModal: true,
            doctorId: location?.state?.doctorId,
            clinicId: location?.state?.clinicId,
            selectedDate: new Date(),
            doctorDetails: location?.state?.doctorDetails,
          },
        });

        setExpertiesData([]);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };

  // get all experties in doctor
  const [expertiesData, setExpertiesData] = useState([])
  const fetchAllExpertiesList = async () => {
    try {
      const response = await getExpertiesById(location?.state?.doctorId, i18n.language);
      if (response?.data?.status !== 200) {
        // toastEmitter("error", response?.data?.message);
        setExpertiesData([]);
      } else {
        const list = response?.data?.data?.expertiseName || [];
        setExpertiesData(list);

        // ✅ auto select first expertise
        if (list.length > 0) {
          setAvailabilityPayload((prev) => ({
            ...prev,
            expertiseName: [
              {
                expertiseName: list[0].expertiseName,
                color: list[0].color || "#000000",
              },
            ],
          }));
        }

        // setExpertiesData(response?.data?.data?.expertiseName);
      }
    } catch (err) {
      // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  useEffect(() => {
    if (location?.state?.doctorId) {
      fetchAllExpertiesList();
    }
  }, [i18n.language, location?.state?.doctorId]);
  console.log("availability payload", availabilityPayload)
  return (
    <>
      <div className="main_datatable my-lg-3 my-2">
        <div className="">
          <BreadCrum
            firstData={t("Availability Management")}
            iconshow1={true}
            secondData={t("Add Availability")}
            onFirstDataClick={handleDataBack}
          />

          <form>
            <div className="card p-1 border p-md-3">
              <div className="d-flex flex-wrap align-items-center mb-3">
                <img
                  src={
                    location?.state?.doctorDetails?.image
                      ? `${API_URL?.ServerURL}${location?.state?.doctorDetails?.image}`
                      : PROFILE_IMG
                  }
                  alt="Profile"
                  className="rounded-3"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
                <div
                  className={` ms-3 ${i18n.language === "ar" ? "me-3" : ""} `}
                >
                  <h5 className="mb-0 fs-6 fw-bolder">
                    {" "}
                    Dr.{" "}
                    {location?.state?.doctorDetails &&
                      location?.state?.doctorDetails?.firstName}{" "}
                    {location?.state?.doctorDetails &&
                      location?.state?.doctorDetails?.lastName}
                  </h5>
                  <p className="text-muted mb-0">
                    {location?.state?.doctorDetails &&
                      location?.state?.doctorDetails?.email}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-lg-5 mb-2">
                  <h5 className="mb-3 fw-bold">{t("Add Availability")}</h5>
                  <div className="card mb-2">
                    <div className="card-body">
                      <Calendar
                        minDate={today}
                        onClickDay={handleDateAdd}
                        locale={i18n.language}
                        value={null}
                        tileClassName={({ date, view }) => {
                          if (view === "month") {
                            const isSelected =
                              availabilityPayload?.repeatForWeek === 1
                                ? weekDays?.some((d) => {
                                  const [day, month, year] = d.split("-");
                                  const formattedD = `${year}-${month}-${day}`;
                                  return dayjs(formattedD).isSame(
                                    dayjs(date),
                                    "day"
                                  );
                                  // return new date(d).toDateString() === date.toDateString() ;
                                })
                                : availabilityPayload?.dateTimeSlotsRequest?.date?.some(
                                  (d) => {
                                    const [day, month, year] = d.split("-");
                                    const formattedD = `${year}-${month}-${day}`;
                                    return dayjs(formattedD).isSame(
                                      dayjs(date),
                                      "day"
                                    );
                                  }
                                );

                            return isSelected
                              ? "rounded10 bg-blue text-white"
                              : null;
                          }
                        }}
                        className="w-100 border-0"
                      />
                    </div>
                  </div>

                  <div className="row ms-1">
                    <div className="form-check col-sm-6">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setRepeatForDay(0);
                            setAvailabilityPayload((prev) => ({
                              ...prev,
                              repeatForWeek: 0,
                              dateTimeSlotsRequest: {
                                ...prev?.dateTimeSlotsRequest,
                                date: [prev?.dateTimeSlotsRequest?.date[0]],
                              },
                            }));
                            setWeekDays([]);
                          }
                        }}
                        checked={repeatForDay === 0}
                      />
                      <label
                        className="form-check-label m-0"
                        htmlFor="exampleCheck1"
                      >
                        {t("noRepeat")}
                      </label>
                    </div>

                    <div className="form-check col-sm-6">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck2"
                        onChange={(e) => {
                          setRepeatForDay(1);
                          setAvailabilityPayload((prev) => ({
                            ...prev,
                            repeatForWeek: 0,
                          }));
                          setWeekDays([]);
                        }}
                        checked={repeatForDay === 1}
                      />
                      <label
                        className="form-check-label m-0"
                        htmlFor="exampleCheck2"
                      >
                        {t("repeatByDate")}
                      </label>
                    </div>

                    <div className=" form-check col-sm-6">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck3"
                        onChange={handleDateRepeatForWeek}
                        checked={repeatForDay === 2}
                      />
                      <label
                        className="form-check-label m-0"
                        for="exampleCheck1"
                      >
                        {t("repeatForWeek")}
                      </label>
                    </div>

                    {availabilityPayload?.dateTimeSlotsRequest?.timeSlots
                      ?.length <= 1 && (
                        <div className=" form-check col-sm-6">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="exampleCheck1"
                            checked={lumpsumpTime}
                            onChange={() => setLumpSumpTime(!lumpsumpTime)}
                          />
                          <label
                            className="form-check-label m-0"
                            for="exampleCheck1"
                          >
                            {t("Create")} full day slot
                          </label>
                        </div>
                      )}
                  </div>
                </div>
                {/* **********************************************
                 ********************************************** */}
                <div className="col-12 col-lg-7 ">
                  <div className="d-flex justify-content-between ">
                    <h5 className="sec-heading my-0 ">{t("Add Time Slot")}</h5>
                    <div className="d-flex gap-2 justify-content-end">
                      <label className="my-0">Appointment duration</label>
                      <input
                        type="number"
                        className="form-control w-25 mb-3 py-0"
                        value={globalTimeSlot}
                        onChange={(e) => setGlobalTimeSlot(e.target.value)}
                        onKeyDown={(e) => {
                          if (
                            [
                              "e",
                              "E",
                              "+",
                              "-",
                              ".",
                              "ArrowUp",
                              "ArrowDown",
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                      />

                      {!lumpsumpTime && (
                        <span
                          onClick={handleAddTimeSlot}
                          className="cursor-pointer"
                        >
                          <img src={SQUARE_PLUS_ICON} alt="square_plus_icon " />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="dropdown-container mb-2">
                    {/* <select
                      className="form-select"
                      name="expertise"
                      value={availabilityPayload?.expertise}
                      onChange={(e) => setAvailabilityPayload(handleFormInput(e, availabilityPayload))}
                    >
                      <option value="" className="font-primary">
                        Select Expertise
                      </option>
                      {expertiesData &&
                        [...expertiesData]
                          .sort((a, b) => a?.expertiseName?.localeCompare(b?.expertiseName))
                          .map((item, index) => (
                            <option key={index} value={item?.expertiseName}>
                              {item?.expertiseName}
                            </option>
                          ))}
                    </select> */}

                    <div className="dropdown w-100 position-relative">
                      <button
                        type="button"
                        className="btn btn-outline-primary dropdown-toggle w-100 text-start"
                        onClick={() =>
                          setAvailabilityPayload((prev) => ({
                            ...prev,
                            isExpertiseOpen: !prev.isExpertiseOpen,
                          }))
                        }
                      >
                        {availabilityPayload.expertiseName?.length > 0 ? (
                          availabilityPayload.expertiseName.map((e, i) => (
                            <span
                              key={i}
                              style={{ color: e.color, fontWeight: "600", marginRight: "6px" }}
                            >
                              {e.expertiseName}
                              {i < availabilityPayload.expertiseName.length - 1 ? "," : ""}
                            </span>
                          ))
                        ) : (
                          t("Select Expertise")
                        )}
                      </button>

                      <ul
                        className={`dropdown-menu w-100 p-2 ${availabilityPayload.isExpertiseOpen ? "show" : ""
                          }`}
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {expertiesData &&
                          [...expertiesData]
                            .sort((a, b) => a.expertiseName.localeCompare(b.expertiseName))
                            .map((item, index) => {
                              const selected = availabilityPayload.expertiseName?.some(
                                (e) => e.expertiseName === item.expertiseName
                              );

                              const existing = availabilityPayload.expertiseName?.find(
                                (e) => e.expertiseName === item.expertiseName
                              );

                              const color =
                                existing?.color ||
                                item.color ||
                                "#000000";
                              return (
                                <li key={index} className="px-1 py-1">
                                  <div className="form-check d-flex align-items-center">
                                    <input
                                      className="form-check-input me-2"
                                      type="checkbox"
                                      id={`expertise-${index}`}
                                      checked={selected}
                                      onChange={() => {
                                        let newExpertise = [...availabilityPayload.expertiseName];

                                        if (selected) {
                                          newExpertise = newExpertise.filter(
                                            (e) => e.expertiseName !== item.expertiseName
                                          );
                                        } else {
                                          newExpertise.push({
                                            expertiseName: item.expertiseName,
                                            color,
                                          });
                                        }

                                        setAvailabilityPayload((prev) => ({
                                          ...prev,
                                          expertiseName: newExpertise,
                                        }));
                                      }}
                                      style={{ accentColor: color }}
                                    />
                                    <p
                                      className="form-check-label mb-0"
                                      htmlFor={`expertise-${index}`}
                                      style={{
                                        cursor: "pointer",
                                        color: color,
                                        fontWeight: selected ? "600" : "400",
                                      }}
                                    >
                                      {item.expertiseName}
                                    </p>
                                  </div>
                                </li>
                              );
                            })}
                      </ul>
                    </div>



                  </div>





                  <div
                    className="overflow-y-auto "
                    style={{ maxHeight: "330px" }}
                  >
                    {availabilityPayload?.dateTimeSlotsRequest?.timeSlots &&
                      availabilityPayload?.dateTimeSlotsRequest?.timeSlots?.map(
                        (slot, slotIndex) => (
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                                <h6 className="card-title fw-normal m-0">
                                  {t("Time Slots")} {slotIndex + 1}
                                </h6>

                                {availabilityPayload?.dateTimeSlotsRequest
                                  ?.timeSlots?.length > 1 && (
                                    <span
                                      className="col text-end"
                                      onClick={() =>
                                        handleDeleteTimeSlot(slotIndex)
                                      }
                                    >
                                      <img
                                        src={DELETE_ICON}
                                        alt="delete_icon"
                                        className="cursor-pointer"
                                      />
                                    </span>
                                  )}
                              </div>
                              <hr className="mt-0" />
                              <div className="d-flex justify-content-between">
                                <div></div>
                              </div>

                              {/* Add slot code  */}
                              <div className="row g-3 ">
                                <div className="">
                                  <div className="d-flex flex-wrap gap-2">
                                    <button
                                      type="button"
                                      className={`btn  ${availabilityPayload
                                        ?.dateTimeSlotsRequest?.timeSlots[
                                        slotIndex
                                      ].type === "online"
                                        ? "btn-primary"
                                        : " btn-outline-info"
                                        } btn-sm  px-4  mb-2 rounded-3`}
                                      onClick={() =>
                                        handleModeChange(slotIndex, "online")
                                      }
                                    >
                                      {t("Online")}
                                    </button>
                                    <button
                                      type="button"
                                      className={`btn ${availabilityPayload
                                        ?.dateTimeSlotsRequest?.timeSlots[
                                        slotIndex
                                      ].type === "offline"
                                        ? "btn-primary"
                                        : "btn-outline-info"
                                        }  btn-sm  px-4 me-2 mb-2 rounded-3`}
                                      onClick={() =>
                                        handleModeChange(slotIndex, "offline")
                                      }
                                    >
                                      {t("Offline")}
                                    </button>
                                  </div>

                                  <div className="row g-2">
                                    <div className="col-6 ">
                                      {/* <TimePicker
                                        value={
                                          slot?.fromTime
                                            ? dayjs(slot?.fromTime, "HH:mm")
                                            : null
                                        }
                                        className={"form-control"}
                                        format="HH:mm"
                                        placeholder="From"
                                        onChange={(time) =>
                                          lumpsumpTime
                                            ? addLumpSumpFrom(time || "")
                                            : handleFrom(time || "", slotIndex)
                                        }
                                      /> */}
                                      <TimePicker
                                        // value={
                                        //   slot?.fromTime
                                        //     ? dayjs(slot?.fromTime, "HH:mm")
                                        //     : null
                                        // }
                                        value={utcToLocalDayjs(slot?.fromTime)}

                                        className={"form-control"}
                                        format="HH:mm"
                                        placeholder="From"
                                        onChange={(time) =>
                                          lumpsumpTime
                                            ? addLumpSumpFrom(time || "")
                                            : handleFrom(time || "", slotIndex)
                                        }
                                        disabledTime={() => {
                                          const selectedDateStr = availabilityPayload?.dateTimeSlotsRequest?.date?.[0]; // e.g., "05-08-2025"
                                          if (!selectedDateStr) return {};

                                          const [day, month, year] = selectedDateStr.split("-");
                                          const selectedDate = dayjs(`${year}-${month}-${day}`, "YYYY-MM-DD");
                                          const now = dayjs();

                                          if (repeatForDay === 0 && selectedDate.isSame(dayjs(), "day")) {
                                            const currentHour = now.hour();
                                            const currentMinute = now.minute();

                                            return {
                                              disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
                                              disabledMinutes: (hour) =>
                                                hour === currentHour
                                                  ? Array.from({ length: currentMinute }, (_, i) => i)
                                                  : [],
                                            };
                                          }

                                          return {};
                                        }}
                                      />

                                    </div>
                                    <div className="col-6">
                                      <TimePicker
                                        // value={
                                        //   slot?.toTime
                                        //     ? dayjs(slot?.toTime, "HH:mm")
                                        //     : null
                                        // }
                                        value={utcToLocalDayjs(slot?.toTime)}

                                        className={"form-control"}
                                        format="HH:mm"
                                        placeholder="To"
                                        onChange={(time) =>
                                          lumpsumpTime
                                            ? addLumpSumpTo(time || "")
                                            : handleTo(time || "", slotIndex)
                                        }
                                        disabled={!slot?.fromTime}
                                        disabledTime={() => {
                                          if (!slot.fromTime) return {};
                                          const fromTime = dayjs(
                                            slot?.fromTime,
                                            "HH:mm"
                                          );
                                          return {
                                            disabledHours: () => [
                                              ...Array(fromTime.hour()).keys(),
                                            ],
                                            disabledMinutes: (h) =>
                                              h === fromTime.hour()
                                                ? [
                                                  ...Array(
                                                    fromTime.minute() +
                                                    globalTimeSlot
                                                  ).keys(),
                                                ]
                                                : [],
                                          };
                                        }}
                                      />
                                    </div>
                                  </div>
                                  {slot?.type === "offline" && (
                                    <div className="row g-2">
                                      <div className=" col-sm-6">
                                        <Input
                                          className="border-radius_input py-2"
                                          type="text"
                                          value={
                                            availabilityPayload
                                              ?.dateTimeSlotsRequest?.timeSlots[
                                              slotIndex
                                            ].location
                                          }
                                          name="location"
                                          disabled
                                          labelName={t("Location")}
                                        />
                                      </div>

                                      {/* <div className="col-sm-6">
                                        <Input
                                          className="border-radius_input py-2"
                                          type="number"
                                          value={
                                            availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex]
                                              .bookingLimit === 0
                                              ? ""
                                              : availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex]
                                                .bookingLimit
                                          }
                                          name="bookingLimit"
                                          labelName={t("Slot Booking Limit")}
                                          onChange={(e) => {
                                            const value = e.target.value === "" ? 0 : parseInt(e.target.value, 10);
                                            setAvailabilityPayload((prev) => {
                                              const updatedSlots = [...prev.dateTimeSlotsRequest.timeSlots];
                                              updatedSlots[slotIndex] = {
                                                ...updatedSlots[slotIndex],
                                                bookingLimit: value,
                                              };
                                              return {
                                                ...prev,
                                                dateTimeSlotsRequest: {
                                                  ...prev.dateTimeSlotsRequest,
                                                  timeSlots: updatedSlots,
                                                },
                                              };
                                            });
                                          }}
                                          onKeyDown={(e) => {
                                            if (
                                              ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(e.key)
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onWheel={(e) => e.target.blur()} // Prevent mouse scroll changing number
                                        />
                                      </div> */}

                                      <div className="col-sm-6">
                                        <Input
                                          type="number"
                                          min={1}
                                          value={
                                            availabilityPayload?.dateTimeSlotsRequest?.timeSlots[slotIndex]
                                              .bookingLimit
                                          }
                                          labelName={t("Slot Booking Limit")}
                                          onChange={(e) => {
                                            const value = Math.max(1, Number(e.target.value || 1));

                                            setAvailabilityPayload((prev) => {
                                              const updatedSlots = [...prev.dateTimeSlotsRequest.timeSlots];
                                              updatedSlots[slotIndex] = {
                                                ...updatedSlots[slotIndex],
                                                bookingLimit: value,
                                              };
                                              return {
                                                ...prev,
                                                dateTimeSlotsRequest: {
                                                  ...prev.dateTimeSlotsRequest,
                                                  timeSlots: updatedSlots,
                                                },
                                              };
                                            });
                                          }}
                                          onKeyDown={(e) => {
                                            if (["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                        />

                                      </div>

                                    </div>
                                  )}


                                </div>
                                {/* ))} */}
                                {commonError.index === slotIndex && (
                                  <span className="fs-6 text-danger">
                                    {" "}
                                    {commonError.err}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
              <div className="d-flex flex-wrap  justify-content-center ">
                <Button
                  type="button"
                  className={`px-5 py-2 rounded border-0  cancelbtn  mb-md-0 mb-2 ${i18n.language === "ar" ? "ms-2" : "me-2"
                    }`}
                  label="Cancel"
                  onClick={handleDataBack}
                />
                <Button
                  type="button"
                  className="px-5 py-2 rounded border-0 text-white submitbtn mb-2 mb-md-0"
                  label={t("Add Availability")}
                  onClick={handleSubmit}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <Modal
        modalId="availabilityadd"
        heading="Availability Added Successfully"
        modalClick={addbuttonClick}
        iconsrc={RIGHTARROW_IMG}
        paragraph="Doctor Availability Added Successfully. You can manage it from availability management section."
        handleModalClose={handleModalClose}
      />
    </>
  );
};

export default AddAvailabilty;
